import React from 'react';
import PropTypes from 'prop-types';

export default class NoResultsCard extends React.Component {
  static propTypes = {
    message: PropTypes.string.isRequired,
    buttons: PropTypes.array
  };

  render() {
    return (
      <div className="col-12">
        <div className="card no-results-card">
          <div className="card-header">
            {this.props.message}
          </div>
          {this.props.buttons && this.props.buttons.length &&
            <div className="card-body">
              <div className="row d-none d-sm-block">
                <div className="col-12">
                  {this.props.buttons.map((button, index) => {
                    return (<a href={button.link} onClick={button.onClick} className="btn btn-primary btn-lg" key={index}>{button.label}</a>)
                  })}
                </div>
              </div>
              <div className="row d-block d-sm-none">
                {this.props.buttons.map((button, index) => {
                  return (<div className="col-12" key={index}>
                    <a href={button.link} className="btn btn-primary btn-block">{button.label}</a>
                  </div>)
                })}
              </div>
            </div>
          }
        </div>
      </div>);
  }
}
